
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M17 11H22V13H17V11Z"></path><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 17H13V22H11V17Z"></path></g><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 11H7V13H2V11Z"></path></g><g opacity="0.6"><path fill-rule="evenodd" clip-rule="evenodd" d="M11 2H13V7H11V2Z"></path></g><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M16.2426 14.8284L19.7782 18.3639L18.364 19.7781L14.8284 16.2426L16.2426 14.8284Z"></path></g><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.75735 14.8284L9.17157 16.2426L5.63603 19.7781L4.22182 18.3639L7.75735 14.8284Z"></path></g><g opacity="0.4"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.63605 4.2218L9.17158 7.75734L7.75737 9.17155L4.22183 5.63602L5.63605 4.2218Z"></path></g><g opacity="0.8"><path fill-rule="evenodd" clip-rule="evenodd" d="M18.364 4.2218L19.7782 5.63602L16.2426 9.17155L14.8284 7.75734L18.364 4.2218Z"></path></g>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiMousewaitFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
